/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  RequestableState,
  createRequestableState,
  handleDone,
  handleFailed,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

export interface State {
  tableCombinations: RequestableState<dashboard.TableCombination[]>;
  createTableCombination: RequestableState<dashboard.TableCombination>;
  deleteTableCombination: RequestableState<any>;
}

export const initialState: State = {
  tableCombinations: createRequestableState<dashboard.TableCombination[]>(),
  createTableCombination: createRequestableState<dashboard.TableCombination>(),
  deleteTableCombination: createRequestableState<any>(),
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type } = action;

  switch (type) {
    case AppConstants.TABLECOMBINATION_FETCH_ALL_STARTING: {
      return {
        ...state,
        tableCombinations: handleStarting(state.tableCombinations, action),
      };
    }
    case AppConstants.TABLECOMBINATION_FETCH_ALL_DONE: {
      return {
        ...state,
        tableCombinations: handleDone(state.tableCombinations, action),
      };
    }
    case AppConstants.TABLECOMBINATION_FETCH_ALL_FAILED: {
      return {
        ...state,
        tableCombinations: handleFailed(state.tableCombinations, action),
      };
    }
    case AppConstants.TABLECOMBINATION_CREATE_STARTING: {
      return {
        ...state,
        createTableCombination: handleStarting(state.createTableCombination, action),
      };
    }
    case AppConstants.TABLECOMBINATION_CREATE_DONE: {
      return {
        ...state,
        createTableCombination: handleDone(state.createTableCombination, action),
      };
    }
    case AppConstants.TABLECOMBINATION_CREATE_FAILED: {
      return {
        ...state,
        createTableCombination: handleFailed(state.createTableCombination, action),
      };
    }
    case AppConstants.TABLECOMBINATION_DELETE_STARTING: {
      return {
        ...state,
        deleteTableCombination: handleStarting(state.deleteTableCombination, action),
      };
    }
    case AppConstants.TABLECOMBINATION_DELETE_DONE: {
      return {
        ...state,
        deleteTableCombination: handleDone(state.deleteTableCombination, action),
      };
    }
    case AppConstants.TABLECOMBINATION_DELETE_FAILED: {
      return {
        ...state,
        deleteTableCombination: handleFailed(state.deleteTableCombination, action),
      };
    }
    default:
      return state;
  }
}
